export default {"src":"/_next/static/media/user.61d21e19.svg","height":96,"width":89,"blurWidth":0,"blurHeight":0};